import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, NavLink } from 'react-router-dom';
import axios from '../../../_services/api/axios';
import withErrorHandler from '../../../_hoc/withErrorHandler';
import * as actionCreators from '../../../_store/actions/index';
import { getTranslate } from 'react-localize-redux';
import * as FormHelpers from '../../../_helpers/Form.js';
import ReactTooltip from 'react-tooltip'

import { PageTemplate, Spacer, Toggle, Header, Form, Button, GreyBox, InputRow, Text, FlexColumn, Input, Select, Box, BoxTitle, Flex } from 'components'

class SettingsJobPresetsPage extends Component {
    defaultFormState = {
        vacation : {
            state : false,
            message : false
        },
        holidays : {
            state : false,
            message : false
        },
        sick : {
            state : false,
            message : false
        },
        training : {
            state : false,
            message : false
        },
        working_hours_each_day : {
            state : false,
            message : false
        },
        monthly_rent : {
            state : false,
            message : false
        },
        overhead : {
            state : false,
            message : false
        },
        gross_hourly_salary : {
            state : false,
            message : false
        },
        currency_code : {
            state : false,
            message : false
        }
    }
    constructor(props) {
        super(props);
            this.state = {
            form : {
                vacation: 0,
                holidays: 0,
                sick: 0,
                training: 0,
                working_hours_each_day: 0,
                monthly_rent: 0,
                overhead: 0,
                gross_hourly_salary: 0,
                currency_code: "",
                recalculate_all_jobs: false
            },
            form_state : this.defaultFormState,
            currency_symbol: "",
            message : {
                show : false,
                message : null
            }
        }
    }
   
    componentDidMount() {
        this.props.onSettingsCompanyFetch();
    }

    componentWillUnmount = () => {
        this.props.onSettingsCompanyUpdateReset();
    }

    componentDidUpdate = (prevProps, prevState, snapshot) => {
        if(prevProps.state.settings !== this.props.state.settings) {
            this.defaultValueHandler();
        }
        if(this.props.state.updated) {
            this.props.onSettingsCompanyUpdateReset();
            this.setState(prevState => ({
                form: {
                    ...prevState.form,
                    recalculate_all_jobs: false
                },
                message: {
                    show: true,
                    message: this.props.translate('settingscompanypage.success.saved'),
                    type: "success"
                },
                form_state: this.defaultFormState
            }), () => {
                ReactTooltip.rebuild();
            });
        }
        else if(prevProps.state.error !== this.props.state.error) {
            if(this.props.state.error.length) {
                this.setState(prevState => ({
                    form_state: this.defaultFormState
                }), () => {
                    this.props.state.error.forEach((error, index) => {
                        if(this.state.form_state[error.source]) {
                            this.setState(prevState => ({
                                form_state : {
                                    ...prevState.form_state,
                                    [error.source] : {
                                        state : 'error',
                                        message : this.props.translate('global.error.'+error.key.toLowerCase()+'.'+error.source.toLowerCase(),null,{missingTranslationMsg: error.message})
                                    }
                                }
                            }))
                        }
                    })
                });
            }
            if(this.props.state.error.length === 1) {
                this.setState(prevState => ({
                    message: {
                        message: this.props.translate('settingscompanypage.error.'+this.props.state.error[0].key.toLowerCase(),null,{missingTranslationMsg: this.props.translate('settingscompanypage.error.default')}),
                        type: "error"
                    }
                }));

            }
            else {
                this.setState(prevState => ({
                    message: {
                        message: this.props.translate('settingscompanypage.error.default'),
                        type: "error"
                    }
                }));
            }
        }
    }

    defaultValueHandler = (event) => {
        if(this.props.state.settings && this.props.state.settings.currency) {
            if(this.props.state.settings.currency) {
                this.setState(prevState => ({
                    form: {
                        ...prevState.form,
                        vacation : this.props.state.settings.vacation,
                        holidays : this.props.state.settings.holidays,
                        sick : this.props.state.settings.sick,
                        training : this.props.state.settings.training,
                        working_hours_each_day : this.props.state.settings.working_hours_each_day,
                        monthly_rent : this.props.state.settings.monthly_rent,
                        overhead : this.props.state.settings.overhead,
                        gross_hourly_salary : this.props.state.settings.gross_hourly_salary,
                        currency_code : this.props.state.settings.currency.code
                    },
                    currency_symbol: this.props.state.settings.currency.symbol
                }))
            }
            else {
                this.setState(prevState => ({
                    form: {
                        ...prevState.form,
                        vacation : this.props.state.settings.vacation,
                        holidays : this.props.state.settings.holidays,
                        sick : this.props.state.settings.sick,
                        training : this.props.state.settings.training,
                        working_hours_each_day : this.props.state.settings.working_hours_each_day,
                        monthly_rent : this.props.state.settings.monthly_rent,
                        overhead : this.props.state.settings.overhead,
                        gross_hourly_salary : this.props.state.settings.gross_hourly_salary
                    }
                }))
            }
        }
    }

    updateHandler = ( event ) => {
        event.preventDefault();
        if(FormHelpers.validateFields.apply(this,[['vacation','holidays','sick','training','working_hours_each_day','monthly_rent','overhead','gross_hourly_salary']])) {
            const formData = {
                vacation : Number.parseFloat(this.state.form.vacation),
                holidays : Number.parseFloat(this.state.form.holidays),
                sick : Number.parseFloat(this.state.form.sick),
                training : Number.parseFloat(this.state.form.training),
                working_hours_each_day : Number.parseFloat(this.state.form.working_hours_each_day),
                monthly_rent : Number.parseFloat(this.state.form.monthly_rent),
                overhead : Number.parseFloat(this.state.form.overhead),
                gross_hourly_salary : Number.parseFloat(this.state.form.gross_hourly_salary),
                recalculate_all_jobs: true,
                currency : {
                    code: this.state.form.currency_code
                }
            };
            this.props.onSettingsCompanyUpdate(formData);
        }
        else {
            this.setState(prevState => ({
                message: {
                    message: this.props.translate('settingscompanypage.error.default'),
                    type: "error"
                }
            }));            
        }
    }

    inputChangedToggle = (value, inputIdentifier) => {
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                [inputIdentifier]: value
            }
        }))
    }

    inputChangedHandler = (event, inputIdentifier) => {
        let value = event.target.value;
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                [inputIdentifier]: value
            }
        }))
    }

    inputBlurredHandler = (event, inputIdentifier) => {
        FormHelpers.validateFields.apply(this,[[inputIdentifier]]);
        if(this.refs[inputIdentifier + "InputRow"]) {
            this.refs[inputIdentifier + "InputRow"].hideTooltip();
        }
    }
    inputFocusHandler = (event, inputIdentifier) => {
        if(this.refs[inputIdentifier + "InputRow"]) {
            this.refs[inputIdentifier + "InputRow"].showTooltip();
        }
    }

    render() {
        var showMessage;
        if(this.state.message.message) {
            showMessage = this.state.message
        }
        return (
            <PageTemplate header={<Header/>}>
                <Form onSubmit={this.updateHandler}>
                    <GreyBox title={this.props.translate('settingscompanypage.title')} msg={showMessage} cols="2">
                        <BoxTitle>{this.props.translate('global.form.label.company.company_information')}</BoxTitle>
                        <Spacer height="15px" />
                        <Flex break="xs">
                            <FlexColumn col="2">
                                <Flex break="m">
                                    <InputRow ref="currency_codeInputRow" label={this.props.translate('global.form.label.company.currency')} state={this.state.form_state.currency_code.state ? this.state.form_state.currency_code.state : null} tip={this.state.form_state.currency_code.message ? this.state.form_state.currency_code.message : null}>
                                        <Select 
                                            identifier="currency_code"
                                            ref="currency_code"
                                            options={this.props.defaults.currencies.map((currency, index) => {return {value: currency.code, name: currency.name}})}
                                            value={this.state.form.currency_code}
                                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
                                    </InputRow>
                                    <InputRow ref="gross_hourly_salaryInputRow" hint={this.props.translate('global.help.company.gross_hourly_salary')} label={this.props.translate('global.form.label.company.gross_hourly_salary')} unit={this.state.currency_symbol} state={this.state.form_state.gross_hourly_salary.state ? this.state.form_state.gross_hourly_salary.state : null} tip={this.state.form_state.gross_hourly_salary.message ? this.state.form_state.gross_hourly_salary.message : null}>
                                        <Input 
                                            identifier="gross_hourly_salary"
                                            ref="gross_hourly_salary"
                                            type="number"
                                            minValue={0}
                                            maxValue={9999}
                                            value={this.state.form.gross_hourly_salary}
                                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true}
                                            step="any"/>
                                    </InputRow>
                                    <InputRow ref="overheadInputRow" hint={this.props.translate('global.help.company.overhead')} label={this.props.translate('global.form.label.company.overhead')} unit={this.state.currency_symbol} state={this.state.form_state.overhead.state ? this.state.form_state.overhead.state : null} tip={this.state.form_state.overhead.message ? this.state.form_state.overhead.message : null}>
                                        <Input 
                                            identifier="overhead"
                                            ref="overhead"
                                            type="number"
                                            minValue={0}
                                            maxValue={99999999}
                                            value={this.state.form.overhead}
                                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true}
                                            step="any" />
                                    </InputRow>
                                    <InputRow ref="monthly_rentInputRow" hint={this.props.translate('global.help.company.monthly_rent')} label={this.props.translate('global.form.label.company.monthly_rent')} unit={this.state.currency_symbol} state={this.state.form_state.monthly_rent.state ? this.state.form_state.monthly_rent.state : null} tip={this.state.form_state.monthly_rent.message ? this.state.form_state.monthly_rent.message : null}>
                                        <Input 
                                            identifier="monthly_rent"
                                            ref="monthly_rent"
                                            type="number"
                                            minValue={0}
                                            maxValue={99999999}
                                            value={this.state.form.monthly_rent}
                                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true}
                                            step="any" />
                                    </InputRow>
                                </Flex>
                            </FlexColumn>
                            <FlexColumn col="2">
                                <Flex>
                                    <InputRow ref="vacationInputRow" hint={this.props.translate('global.help.company.vacation')} label={this.props.translate('global.form.label.company.vacation')} unit={this.props.translate('global.units.days')} state={this.state.form_state.vacation.state ? this.state.form_state.vacation.state : null} tip={this.state.form_state.vacation.message ? this.state.form_state.vacation.message : null}>
                                        <Input 
                                            identifier="vacation"
                                            ref="vacation"
                                            type="number"
                                            minValue={0}
                                            maxValue={9999}
                                            value={this.state.form.vacation}
                                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true}
                                            step="any" />
                                    </InputRow>
                                    <InputRow ref="holidaysInputRow" hint={this.props.translate('global.help.company.holidays')} label={this.props.translate('global.form.label.company.holidays')} unit={this.props.translate('global.units.days')} state={this.state.form_state.holidays.state ? this.state.form_state.holidays.state : null} tip={this.state.form_state.holidays.message ? this.state.form_state.holidays.message : null}>
                                        <Input 
                                            identifier="holidays"
                                            ref="holidays"
                                            type="number"
                                            minValue={0}
                                            maxValue={365}
                                            value={this.state.form.holidays}
                                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true}
                                            step="any" />
                                    </InputRow>
                                    <InputRow ref="sickInputRow" hint={this.props.translate('global.help.company.sick')} label={this.props.translate('global.form.label.company.sick')} unit={this.props.translate('global.units.days')} state={this.state.form_state.sick.state ? this.state.form_state.sick.state : null} tip={this.state.form_state.sick.message ? this.state.form_state.sick.message : null}>
                                        <Input 
                                            identifier="sick"
                                            ref="sick"
                                            type="number"
                                            minValue={0}
                                            maxValue={365}
                                            value={this.state.form.sick}
                                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true}
                                            step="any" />
                                    </InputRow>
                                    <InputRow ref="trainingInputRow" hint={this.props.translate('global.help.company.training')} label={this.props.translate('global.form.label.company.training')} unit={this.props.translate('global.units.days')} state={this.state.form_state.training.state ? this.state.form_state.training.state : null} tip={this.state.form_state.training.message ? this.state.form_state.training.message : null}>
                                        <Input 
                                            identifier="training"
                                            ref="training"
                                            type="number"
                                            minValue={0}
                                            maxValue={365}
                                            value={this.state.form.training}
                                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true}
                                            step="any" />
                                    </InputRow>
                                    <InputRow ref="working_hours_each_dayInputRow" hint={this.props.translate('global.help.company.working_hours_each_day')} label={this.props.translate('global.form.label.company.working_hours_each_day')} unit={this.props.translate('global.units.hours')} state={this.state.form_state.working_hours_each_day.state ? this.state.form_state.working_hours_each_day.state : null} tip={this.state.form_state.working_hours_each_day.message ? this.state.form_state.working_hours_each_day.message : null}>
                                        <Input 
                                            identifier="working_hours_each_day"
                                            ref="working_hours_each_day"
                                            type="number"
                                            minValue={0.1}
                                            maxValue={24}
                                            value={this.state.form.working_hours_each_day}
                                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true}
                                            step="any"
                                            validationPattern="^\d*(\.\d{0,2})?$" />
                                    </InputRow>
                                </Flex>
                            </FlexColumn>
                        </Flex>
                        <Flex reverse="m">
                            <Button data-cy="cancel-edit-company-btn" href="/jobs" type="button" theme="light" value={this.props.translate('settingscompanypage.secondary.label')} width="320px" />
                            <Button data-cy="save-changes-edit-company-btn"  value={this.props.translate('settingscompanypage.submit')} type="submit" width="320px" /> 
                        </Flex>                               
                    </GreyBox>
                </Form>
            </PageTemplate>
        );
    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
        defaults: state.defaults,
        state: state.calculatorSettingsCompany,
        translate: getTranslate(state.locale)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSettingsCompanyUpdate: (formData) => dispatch(actionCreators.settingsCompanyUpdate(formData)),
        onSettingsCompanyFetch: () => dispatch(actionCreators.settingsCompanyFetch()),
        onSettingsCompanyUpdateReset: () => dispatch(actionCreators.settingsCompanyUpdateReset()),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(SettingsJobPresetsPage, axios));


// WEBPACK FOOTER //
// ./src/components/pages/SettingsCompanyPage/index.js